import { Box, Button, Heading, HStack, Link, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const phone = '994773292228';
const message = encodeURIComponent('Salam, CaspiPos haqqında məlumat almaq istəyirəm');

export const Contact: React.FC = () => {
  return (
    <Box bg="gray.900" py={20} px={6} textAlign="center" id="contact">
      <VStack maxW="600px" mx="auto">
        <HStack justify="center" w="100%">
          <VStack>
            <Heading size="2xl" color="white">
              24/7
            </Heading>
            <Text mb={4} color="gray.400" fontSize="md">
              Dəstək
            </Text>
            <Link
              href={`https://wa.me/${phone}?text=${message}`}
              padding={"8px"}
              target="_blank"
              rel="noopener noreferrer"
              bg="#22C55E"
              color="#fff"
            >
              Bizimlə Əlaqə Saxlayın
            </Link>
          </VStack>
        </HStack>

        <Text mt={4} color="gray.400" fontSize="sm">
          24 saat ərzində fərdi demonuzu təşkil etmək üçün sizinlə əlaqə saxlayacağıq.
        </Text>
      </VStack>
    </Box>
  );
};
